<!-- TabPanel.svelte -->
<script lang="ts">
	import { getContext } from 'svelte'
	import type { TabContext } from '$lib/stores/tab-context'

	interface Props {
		index: number;
		children?: import('svelte').Snippet;
		[key: string]: any
	}

	let { ...props }: Props = $props();

	const { selected } = getContext<TabContext>('tabs')
	let isSelected = $derived($selected === props.index)
</script>

{#if isSelected}
	<div
		{...props}
		role="tabpanel"
		tabindex="0"
		aria-labelledby={`tab-${props.index}`}
		class={props.class}
	>
		{@render props.children?.()}
	</div>
{/if}
